/* eslint-disable no-console */
import {formatIndian} from './formatIndian';

interface ConvertedValue {
  value: number | string;
  unit: string;
}

export const convertGjToTjWithUnit = (
  value: number | string,
  unit: string | undefined = ''
): string => {
  const obj = convertGjToTjValueUnitObject(value, unit);

  return `${obj.value} ${obj.unit}`;
};

export const convertGjToTjValue = (
  value: number | string,
  unit: string | undefined = ''
): string => {
  const obj = convertGjToTjValueUnitObject(value, unit);

  return `${obj.value}`;
};

export const convertGjToTjValueUnitObject = (
  value: number | string,
  unit: string | undefined = ''
): ConvertedValue => {
  const rawValue =
    typeof value === 'string' ? value.replaceAll(',', '') : value;
  let numericValue = Number(rawValue);

  // If value is not a valid number
  if (isNaN(numericValue) && unit === 'GJ') {
    return {value: '0.00', unit: 'TJ'};
  }
  if (isNaN(numericValue) && unit === 'GJ/Sq ft') {
    return {value: '0.00', unit: 'TJ/Sq ft'};
  }

  if (
    unit?.toLocaleLowerCase().trim() === 'gj' ||
    unit?.toLocaleLowerCase().trim() === 'gj/sq ft'
  ) {
    numericValue = numericValue / 1000;
    const formattedValue = formatIndian(parseFloat(numericValue.toFixed(12)));
    if (unit?.toLocaleLowerCase().trim() === 'gj') {
      return {value: formattedValue, unit: 'TJ'};
    }
    if (unit?.toLocaleLowerCase().trim() === 'gj/sq ft') {
      return {value: formattedValue, unit: 'TJ/Sq ft'};
    }
  }

  const finalFormatted = formatIndian(numericValue.toFixed(2));

  if (finalFormatted === 'NA' || finalFormatted === '-' || numericValue === 0) {
    return {value: '0.00', unit: 'TJ'};
  }

  return {value: finalFormatted, unit: unit || ''};
};
